import { useCallback } from 'react';

function useInput(props) {
    const {
        onChange
    } = props;

    function handleChange(e) {
        if (onChange) onChange(e);
    }

    return {
        handleChange: useCallback(handleChange, [])
    };
}

export default useInput;
